import { ColumnDef } from "@tanstack/react-table";
import { getStickyColumnClasses } from "@/lib/styleHelpers";
import { DuesRatesRow } from "../types";
import Tooltip from "@/components/Tooltip";
import { renderStatusIcon } from "@/pages/billing/dues-management/manage-products/annual-national-rates/_utils";

interface GetColumnsProps {
  tableData: DuesRatesRow[];
  currentYear: number;
}

export const getColumns = ({ tableData, currentYear }: GetColumnsProps): ColumnDef<DuesRatesRow, any>[] => [
  {
    header: "Section",
    accessorKey: "section",
    meta: {
      className: getStickyColumnClasses(!!tableData?.length)
    },
    enableSorting: false
  },
  {
    header: "Product",
    accessorKey: "productName",
    enableSorting: false
  },
  {
    header: "Classification",
    accessorKey: "classification",
    enableSorting: false,
    cell: ({ row }) => {
      return (
        <Tooltip
          variant="plain"
          supportingText={row.original.classificationDescription}
          color="black"
          menuCorner="end-start"
          anchorCorner="start-start"
        >
          {row.original.classification}
        </Tooltip>
      );
    }
  },
  {
    header: `${currentYear} Rate`,
    accessorKey: "rate_current_year",
    enableSorting: false,
    cell: ({ row }) => {
      const { status, statusMessage } = row.original;
      return (
        <div className="flex items-center">
          {status ? <div className="ml-2 mt-1">{renderStatusIcon(status, statusMessage)}</div> : null}
          <div className="flex items-center">{row.original.rate_current_year}</div>
        </div>
      );
    }
  },
  {
    header: `${currentYear - 1} Rate`,
    accessorKey: "rate_previous_year",
    enableSorting: false
  },
  {
    header: `${currentYear - 2} Rate`,
    accessorKey: "rate_previous_year_2",
    enableSorting: false
  },
  {
    header: "Modified",
    accessorKey: "updatedAt",
    enableSorting: false
  }
];
